import { render, staticRenderFns } from "./LawMatterFileTypeForm.vue?vue&type=template&id=351cbf58&"
import script from "./LawMatterFileTypeForm.vue?vue&type=script&lang=js&"
export * from "./LawMatterFileTypeForm.vue?vue&type=script&lang=js&"
import style0 from "./LawMatterFileTypeForm.vue?vue&type=style&index=0&id=351cbf58&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports